import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { UserListModel } from '@app/modules/fund-management/account-user/user-list.model';
import { IEditService, IListService } from '@app/services';

@Injectable()
export class SavedReportFilterUserService implements IListService, IEditService<UserListModel> {
	endpointBase = '/api/saved-report-filter';

	constructor(private readonly http: HttpClient) {}

	getList(): Observable<any> {
		return EMPTY;
	}

	public getById(): Observable<any> {
		return EMPTY;
	}

	public getUsers(): Observable<any> {
		return this.http.get(`${this.endpointBase}/users`);
	}

	public createEntity(): Observable<any> {
		return EMPTY;
	}

	public deleteEntity(): Observable<any> {
		return EMPTY;
	}

	public updateEntity(): Observable<any> {
		return EMPTY;
	}
}
